import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const LabourDetailReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/standardreport");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  

  const handleFDateChange = (e) => {
   
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

 

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

 

  const FillReport = (employeeId, farmActivityId) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);
    setCurrentPage(1);
    //console.log("d", d);
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    //var tdate=moment(selectedToDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (farmActivityId > 0) {
      urlfilter = urlfilter + `&farmActivityId=${farmActivityId}`;
    }

 

    var url = `/api/labourReportMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getFiedlActivity } = useHttp();
  useEffect(() => {
    getFiedlActivity(
      {
        url: `/api/farmActivity/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("farmActivity", data);
        setFarmActivityData(data);
      }
    );
  }, [getFiedlActivity]);



  const fieldsToExport = [
    "startDate",
    "FieldActivityNo",
    "farmManager",
    "plotName",
    "plotArea",
    "plotAreaUnit",
    "cropName",
    "varietyName",
    "areaCovered",
    "areaCoveredUnit",
    "fieldActivityName",
  ];

  const customHeaders = [
    "Date",
    "FieldActivityNo",
    "Farm Manager",
    "Plot Name",
    "Plot Area",
    "Unit",
    "Crop Name",
    "Variety Name",
    "Area Covered",
    "Area Covered Unit",
    "Activity Name",
    "Labour Type",
    "Hrs/Labour",
    "Total Hrs",
    "Cost",
  ];

  const handleExportExcel = () => {
    const filename = "LabourReport.xlsx";
    //  //console.log(fieldsToExport,customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Activity Labour Detail Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <hr />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
              <div className="form-group">
                  <label>Field Activity </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={farmActivityId}
                    onChange={(e) => setFarmActivityId(e.target.value)}
                  >
                    <option value="">Select</option>
                    {farmActivityData &&
                      farmActivityData.map((x) => (
                        <option
                          key={x.fieldActivityId}
                          fieldActivity-Id={x.fieldActivityId}
                          value={x.fieldActivityId}
                        >
                          {x.fieldActivityName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, farmActivityId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Date </th>
                          <th> FieldActivityNo </th>
                          <th>Farm Manager</th>
                          {/* <th>	Farm Name	</th> */}
                          <th>Plot Name </th>
                          <th> Plot Area </th>
                          <th> Unit </th>
                          <th> Crop Name </th>
                          <th>Variety Name </th>
                          <th> Area Covered </th>
                          <th> Unit</th>
                          <th> Activity Name </th>

                          <th> Labour Type </th>
                          <th> Hrs/Labour </th>
                          <th> Total Hrs </th>
                          <th>Cost</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.startDate}</td>
                                <td>{itm.FieldActivityNo}</td>

                                <td>{itm.farmManager}</td>

                                <td>{itm.plotName}</td>

                                <td> {itm.plotArea} </td>
                                <td> {itm.plotAreaUnit} </td>
                                <td> {itm.cropName} </td>
                                <td> {itm.varietyName} </td>

                                <td> {itm.areaCovered} </td>
                                <td> {itm.areaCoveredUnit} </td>
                                <td> {itm.fieldActivityName} </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LabourDetailReport;
